import { render } from "./UserDisplayCard.vue?vue&type=template&id=19d4e598&ts=true"
import script from "./UserDisplayCard.vue?vue&type=script&lang=ts"
export * from "./UserDisplayCard.vue?vue&type=script&lang=ts"

import "./UserDisplayCard.vue?vue&type=style&index=0&id=19d4e598&lang=scss"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg,QCardSection,QList,QItem,QItemSection,QItemLabel});
